module.exports = __webpack_public_path__ + "img/bluesky3100_32.29eb9b8e.jpg";